// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Irml","gfeWrapper":"CalendarEvent_gfeWrapper__3soLh"};